import React from "react";
import { faShieldHalved } from "@fortawesome/free-solid-svg-icons";
import SplitBadge from "./SplitBadge";
import { getElementDamageValue } from "../utils/damageCombinations";

/**
 * Tree badge for damage-combination splits. A distinct icon from the
 * access-methods badge so the two editors are told apart at a glance,
 * even though they open the same form.
 */
const DamageCombinationsBadge = ({ element, mode, onEdit }) => (
  <SplitBadge
    element={element}
    mode={mode}
    onEdit={onEdit}
    icon={faShieldHalved}
    getElementValue={getElementDamageValue}
    popoverTitle="Damage combinations (m²)"
    emptyLabel="No damage combination set"
    unassignedLabel="No combination"
    className="badge-damage"
  />
);

export default DamageCombinationsBadge;
